import { LIST_getInstance2vniy0f7mmb29 as LIST_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  toList3jhuyej2anx2q as toList,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { listElement3jy3tr2z6og1q as listElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { subrendererSelector1yvbedolu35d3 as subrendererSelector } from './helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_shown_$ref_kipsub2u3yvjqlogkp3 as TextView$_get_shown_$ref_kipsub,
  TextView$_set_shown_$ref_l7jsq921p8dnwznnah1 as TextView$_set_shown_$ref_l7jsq9,
} from './CsvRenderer.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { lensByElementAssumingSetNeverManipulates1yt8q6qtxcnsa as lensByElementAssumingSetNeverManipulates } from '../../../../../reactive/com/lightningkite/reactive/lensing/LensByElementAssumingSetNeverManipulates.mjs';
import {
  weight31wqab1913ly4 as weight,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { flattenml92kmikh8fo as flatten } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { forEachUpdating3is0lusemmftw as forEachUpdating } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/foreach.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { h42yee57ysxgrns as h4 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerSet(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, LIST_getInstance()), SetRenderer_instance);
}
function SetRenderer$form$lambda$lambda(it) {
  return toList(it);
}
function SetRenderer$form$lambda$lambda_0(it) {
  return toSet(it);
}
function SetRenderer$form$lambda$lambda$slambda($itemLens, $value) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $itemLens;
    var item = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $value;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    yield* $value.set_revjhg_k$(minus(tmp$ret$1, item), $completion);
    return Unit_instance;
  }), 0);
}
function SetRenderer$form$lambda$slambda($value, $elementSerializer) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $value;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* $value.set_revjhg_k$(plus(tmp$ret$0, default_0($elementSerializer)), $completion);
    return Unit_instance;
  }), 0);
}
function SetRenderer$view$lambda$lambda(it) {
  return toList(it);
}
var SetRendererClass;
function SetRenderer() {
  if (SetRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Set';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_wxiuk5_k$(context, module_0) {
        var descriptor = context.serializer_1.get_descriptor_wjt6a0_k$();
        return equals(descriptor.get_kind_wop7ml_k$(), LIST_getInstance()) && contains(descriptor.get_serialName_u2rqhk_k$(), 'Set') ? 0.85 : -1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_wxiuk5_k$(context, module_0);
      }
      form_icvn38_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var tmp = listElement(context.serializer_1);
          var elementSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
          var elementContext = new (RenderContext())(elementSerializer);
          var elementRenderers = module_0.selectAll_bhj9zi_k$(elementContext);
          var selectedRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(elementContext));
          var tmp_0 = SetRenderer$form$lambda$lambda;
          var listValue = value.lens_drj4fu_k$(tmp_0, SetRenderer$form$lambda$lambda_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_gap_jwjroq_k$(get_px(0));
          if (module_0.enableRendererSwitching_1) {
            subrendererSelector(element, selectedRenderer, elementRenderers);
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp_1 = KMutableProperty0();
          var tmp_2 = TextView$_get_shown_$ref_kipsub(element_0);
          var tmp_3 = getPropertyCallableRef('shown', 0, tmp_1, tmp_2, TextView$_set_shown_$ref_l7jsq9(element_0));
          element_0.invoke_bnq13k_k$(tmp_3, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).isEmpty_y1axqb_k$());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_4 = element_0.native_1;
          var tmp_5;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_5 = '\xA0';
          } else {
            tmp_5 = 'Empty';
          }
          tmp_4.set_content_i5lrjv_k$(tmp_5);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = themed(element, ListSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          element_1.set_vertical_nuap32_k$(true);
          var tmp_6 = lensByElementAssumingSetNeverManipulates(listValue);
          forEachUpdating(element_1, tmp_6, VOID, VOID, ($this$forEachUpdating, itemLens) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            var this_0 = themed($this$forEachUpdating, CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
            ensureOutermostElement(element);
            this_0.willAddChild_hz2iwc_k$(element);
            element.set_vertical_nuap32_k$(false);
            // Inline function 'com.lightningkite.kiteui.views.expanding' call
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            var this_1 = weight(element, 1.0);
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (Frame())(this_1.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            this_1.willAddChild_hz2iwc_k$(element_0);
            var $this$frame = element_0;
            reactive($this$frame, VOID, ($this$reactive) => {
              $this$frame.clearChildren_eufjq4_k$();
              $this$reactive.invoke_r7m7el_k$(selectedRenderer).form_gie6yk_k$(elementContext, flatten(itemLens), module_0)($this$frame);
              return Unit_instance;
            });
            element_0.onStartup_vrxh3i_k$();
            this_1.addChild_2qpft2_k$(element_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (Button())(element.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            element.willAddChild_hz2iwc_k$(element_1);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().close_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_2 = new (IconView())(element_1.get_context_h02k06_k$());
            ensureOutermostElement(element_2);
            element_1.willAddChild_hz2iwc_k$(element_2);
            element_2.set_source_3o5lkf_k$(icon);
            element_2.set_description_s1386w_k$('Remove');
            element_2.onStartup_vrxh3i_k$();
            element_1.addChild_2qpft2_k$(element_2);
            onClick(element_1, VOID, VOID, VOID, SetRenderer$form$lambda$lambda$slambda(itemLens, value));
            element_1.onStartup_vrxh3i_k$();
            element.addChild_2qpft2_k$(element_1);
            element.onStartup_vrxh3i_k$();
            this_0.addChild_2qpft2_k$(element);
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (Button())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          element.willAddChild_hz2iwc_k$(element_2);
          var tmp0 = get_centered(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = Companion_getInstance().add_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (IconView())(tmp0.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          tmp0.willAddChild_hz2iwc_k$(element_3);
          element_3.set_source_3o5lkf_k$(icon);
          element_3.set_description_s1386w_k$('Add');
          element_3.onStartup_vrxh3i_k$();
          tmp0.addChild_2qpft2_k$(element_3);
          onClick(element_2, VOID, VOID, VOID, SetRenderer$form$lambda$slambda(value, elementSerializer));
          element_2.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_2);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_icvn38_k$(context, value, module_0);
      }
      view_l231d_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var tmp = listElement(context.serializer_1);
          var elementSerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
          var elementContext = new (RenderContext())(elementSerializer);
          var elementRenderers = module_0.selectAll_bhj9zi_k$(elementContext);
          var selectedRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(elementContext));
          var listValue = lens(value, SetRenderer$view$lambda$lambda);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_gap_jwjroq_k$(get_px(0));
          if (module_0.enableRendererSwitching_1) {
            subrendererSelector(element, selectedRenderer, elementRenderers);
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_0);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_0));
          element_0.invoke_bnq13k_k$(tmp_2, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).isEmpty_y1axqb_k$());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_3 = element_0.native_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = 'Empty';
          }
          tmp_3.set_content_i5lrjv_k$(tmp_4);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = themed(element, ListSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          element_1.set_vertical_nuap32_k$(true);
          forEachUpdating(element_1, listValue, VOID, VOID, ($this$forEachUpdating, itemValue) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            var this_0 = themed($this$forEachUpdating, CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (Frame())(this_0.get_context_h02k06_k$());
            ensureOutermostElement(element);
            this_0.willAddChild_hz2iwc_k$(element);
            var $this$frame = element;
            reactive($this$frame, VOID, ($this$reactive) => {
              $this$frame.clearChildren_eufjq4_k$();
              $this$reactive.invoke_r7m7el_k$(selectedRenderer).view_bqdmap_k$(elementContext, itemValue, module_0)($this$frame);
              return Unit_instance;
            });
            element.onStartup_vrxh3i_k$();
            this_0.addChild_2qpft2_k$(element);
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_l231d_k$(context, value, module_0);
      }
      cellView_pretst_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => '' + $this$invoke.invoke_r7m7el_k$(value).get_size_woubt6_k$() + ' items');
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_pretst_k$(context, value, module_0);
      }
      columnWidth_m1om8x_k$(context, module_0) {
        return 10.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_m1om8x_k$(context, module_0);
      }
      labeledForm_l2q7p2_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element_0), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          SetRenderer_instance.form_icvn38_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_l2q7p2_k$(context, value, module_0, label, description);
      }
      labeledView_px4o6f_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element_0), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          SetRenderer_instance.view_l231d_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_px4o6f_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'SetRenderer', VOID, VOID, [Renderer()]);
    SetRendererClass = $;
  }
  return SetRendererClass;
}
var SetRenderer_instance;
function SetRenderer_getInstance() {
  return SetRenderer_instance;
}
//region block: init
SetRenderer_instance = new (SetRenderer())();
//endregion
//region block: exports
export {
  registerSet as registerSet1ljcp26q8gzm8,
};
//endregion

//# sourceMappingURL=SetRenderer.mjs.map
